import { FC } from 'react';
import { Card, Button } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../../../Localization';

interface ConsentModalProps {
  showingConsentBox: 'notice' | 'script' | null;
  onStartCall: () => void;
  onCancel: () => void;
  onConsentGranted: () => void;
  onConsentDenied: () => void;
  callAnswered: boolean;
  customConsentScript?: string;
}

/**
 * Modal component for consent to record flow
 * Shows notice and script stages
 */
export const ConsentModal: FC<ConsentModalProps> = ({
  showingConsentBox,
  onStartCall,
  onCancel,
  onConsentGranted,
  onConsentDenied,
  callAnswered,
  customConsentScript
}) => {
  const L = useLocalizedStrings();

  if (!showingConsentBox) return null;

  return (
    <Card className={`p-2 transition duration-700 ${showingConsentBox === 'notice' ? 'bg-yellow-100' : ''} ${showingConsentBox === 'script' ? 'bg-gray-100' : ''}`}>
      {showingConsentBox === 'notice' && (
        <div className="text-sm">
          <h6>{L.applicant.comms.consent.important_notice}</h6>
          <div className='mb-2'>{L.applicant.comms.consent.please_read_script}</div>
          <div>{L.applicant.comms.consent.you_may_proceed}</div>
          <div className="flex justify-end gap-3 mt-3">
            <Button onClick={onStartCall}>{L.applicant.comms.consent.start_call}</Button>
            <Button variant="secondary" onClick={onCancel}>{L.applicant.comms.consent.cancel}</Button>
          </div>
        </div>
      )}
      {showingConsentBox === 'script' && (
        <div className="text-sm">
          <h6 className="mb-2">{L.applicant.comms.consent.read_this_script}</h6>
          <div className="italic">{customConsentScript || L.applicant.comms.consent.default_script}</div>
          <div className="my-2">{L.applicant.comms.consent.did_user_consent}</div>
          <div className="flex flex-col w-full justify-end gap-2">
            <Button isDisabled={!callAnswered} onClick={onConsentGranted}>
              {L.applicant.comms.consent.yes_start_recording}
            </Button>
            <Button
              variant={callAnswered ? 'danger' : undefined}
              isDisabled={!callAnswered}
              onClick={onConsentDenied}
            >
              {L.applicant.comms.consent.no_do_not_record}
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};
